import React, { useEffect, useState } from "react";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";

const ProgressReportCard = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.data?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [houseDetails, setHouseDetails] = useState([]);
  const [careTakerDetails, setCareTakerDetails] = useState([]);
  const [latestInvoice, setLatestInvoice] = useState([]);
  const [paymentProgress, setPaymentProgress] = useState([]);

  useEffect(() => {
    console.log(user);
    dispatch(getProfile({ userId: id })).then((res) => {
      console.log("profile update", res);
      setProfileUpdated(true);
      setHouseDetails(res?.payload?.data?.tenant_details.house_info);
      setCareTakerDetails(res?.payload?.data?.tenant_details.caretaker);
      setLatestInvoice(res?.payload?.data?.tenant_details.unpaidInvoices);
      setPaymentProgress(res?.payload?.data?.tenant_details.payments?.[0]);
    });
  }, [user]);

  const invoicePendingDetails = {
    Title: "Invoices Pending",
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    serviceCharge: latestInvoice.serviceCharge || "0",
    unpaidDeposit: latestInvoice.unpaidDeposit || "0",
    garbage: latestInvoice?.garbage || "0",
    totalAmount:
      (latestInvoice?.rent || 0) +
      (latestInvoice?.water || 0) +
      (latestInvoice?.arrears || 0) +
      // (latestInvoice.serviceCharge || 0) +
      // (latestInvoice.unpaidDeposit || 0) +
      (latestInvoice?.garbage || 0),
  };

  const invoicePaidDetails = {
    Title: "Invoices Paid",
    rent: Number(paymentProgress?.rent_amount) || "0",
    water: Number(paymentProgress?.water_bill_amount) || "0",
    arrears: Number(paymentProgress?.arrears_amount) || "0",
    serviceCharge: Number(paymentProgress?.service_fee_amount) || "0",
    unpaidDeposit: Number(paymentProgress?.unpaidDeposit) || "0",
    garbage: Number(paymentProgress?.garbage_charge_amount) || "0",
    totalAmount:
      Number(paymentProgress?.rent_amount || 0) +
      Number(paymentProgress?.water_bill_amount || 0) +
      Number(paymentProgress?.arrears_amount || 0) +
      // (paymentProgress.serviceCharge || 0) +
      // (paymentProgress.unpaidDeposit || 0) +
      Number(paymentProgress?.garbage_charge_amount || 0),
  };

  const totalValueDetails = {
    rent: invoicePaidDetails.rent,
    water: invoicePaidDetails.water,
    arrears: invoicePaidDetails.arrears,
    serviceCharge: invoicePaidDetails.serviceCharge,
    unpaidDeposit: invoicePaidDetails.unpaidDeposit,
    garbage: invoicePaidDetails.garbage,
    totalAmount:
      invoicePendingDetails?.totalAmount + invoicePaidDetails?.totalAmount,
  };

  const total = totalValueDetails?.totalAmount;

  const totalIndividuals = [
    invoicePaidDetails?.rent + invoicePendingDetails?.rent,
    invoicePaidDetails?.water + Number(invoicePendingDetails?.water),
    Number(invoicePaidDetails?.arrears) +
      Number(invoicePendingDetails?.arrears),
    invoicePaidDetails?.garbage + Number(invoicePendingDetails?.garbage),
    Number(invoicePaidDetails?.serviceCharge) +
      Number(invoicePendingDetails?.serviceCharge) +
      Number(invoicePaidDetails?.unpaidDeposit) +
      Number(invoicePendingDetails?.unpaidDeposit),
  ];
  console.log("Total Individuals", totalIndividuals);
  console.log(
    "Water",
    invoicePaidDetails?.water,
    "Water 2",
    invoicePendingDetails?.water
  );
  useEffect(() => {
    console.log("Total Value Details", totalValueDetails.totalAmount);
  }, [totalValueDetails]);

  // Sample data for the component
  const salesData = [
    { label: "Rent", value: totalValueDetails.rent, color: "#293947" },
    { label: "Water", value: totalValueDetails.water, color: "#64A371" },
    { label: "Arrears", value: totalValueDetails.arrears, color: "#B99963" },
    { label: "Garbage", value: totalValueDetails.garbage, color: "#377771" },
    {
      label: "Other Charges",
      value: totalValueDetails.garbage,
      color: "#192A3A",
    },
  ];

  return (
    <div style={styles.card}>
      <h3 style={styles.title}>Payment Progress Report</h3>
      {salesData.map((data, index) => (
        <div key={data.label} style={styles.dataRow}>
          <span style={styles.label}>{data.label}</span>
          <div style={styles.progressBarContainer}>
            <div
              style={{
                ...styles.progressBar,
                width: `${(data.value / totalIndividuals[index]) * 100}%`, // Assuming 600 is the max value for the width calculation
                backgroundColor: data.color,
              }}
            />
          </div>
          <span style={styles.value}>{data.value}</span>
        </div>
      ))}
    </div>
  );
};

const styles = {
  card: {
    width: "100%", // You can adjust the width
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: "18px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
    marginBottom: "20px",
  },
  dataRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    fontFamily: "Karla, sans-serif",
  },
  label: {
    flex: "1",
    fontSize: "16px",
    fontWeight: "500",
  },
  progressBarContainer: {
    flex: "2",
    height: "8px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    marginRight: "10px",
  },
  progressBar: {
    height: "100%",
    borderRadius: "4px",
  },
  value: {
    fontSize: "14px",
    fontWeight: "bold",
  },
};

export default ProgressReportCard;
